import { Box, Flex } from '@chakra-ui/react';
import { NotFound, useMobileContext } from '@shared';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import Sidebar from './components/sidebar/SuperadminSidebar';
import { MobileHeader } from './components/mobile/SuperadminMobileHeader';
import Accounts from './views/accounts/SuperadminAccounts';
import Users from './views/users/SuperadminUsers';
import { useEffect } from 'react';
import SmsMessages from './views/SuperadminSmsMessages';
import Overview from './views/overview/SuperadminOverview';
import Superadmins from './views/superadmins/Superadmins';
import DiscountCodes from './views/discountCodes/DiscountCodes';
import Announcements from './views/announcements/Announcements';
import InboundNumbers from './views/inboundNumbers/SuperadminInboundNumbers';
import Surveys from './views/surveys/Surveys';
import Orders from './views/orders/SuperadminOrders';
import Order from './views/orders/Order';
import SenderNamesPage from './views/senderNames/SuperadminSenderNames';

export function SuperadminRoutes() {
	const { isMobile } = useMobileContext();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (pathname === '/') {
			navigate('overview');
		}
	}, [pathname, navigate]);

	if (isMobile) {
		return (
			<Flex height={'100%'} flexDirection={'column'}>
				<MobileHeader />
				<Content />
			</Flex>
		);
	}
	return (
		<Flex height={'100%'} width={'100%'}>
			<Sidebar />
			<Content />
		</Flex>
	);
}

function Content() {
	return (
		<Flex width={'100%'} height={'100%'} overflow={'auto'} background={'white'}>
			<Box padding={5} width={'100%'} overflow={'auto'}>
				<Routes>
					<Route path="/overview" element={<Overview />} />
					<Route path="/accounts" element={<Accounts />} />
					<Route path="/users" element={<Users />} />
					<Route path="/superadmins" element={<Superadmins />} />
					<Route path="/sms-messages" element={<SmsMessages />} />
					<Route path="/orders" element={<Orders />} />
					<Route path="/orders/:id" element={<Order />} />

					<Route path="/discount-codes" element={<DiscountCodes />} />
					<Route path="/announcements" element={<Announcements />} />
					<Route path="/inbound-numbers" element={<InboundNumbers />} />
					<Route path="/sender-names" element={<SenderNamesPage />} />

					<Route path="/surveys" element={<Surveys />} />

					<Route path="*" element={<NotFound />} />
				</Routes>
			</Box>
		</Flex>
	);
}
